import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';
import Header from '../components/Header';
import BookCover from '../components/sections/BookCover';
import Chapters from '../components/sections/Chapters';
import Content from '../components/sections/Content';
import CoursesSection from '../components/sections/CoursesSection';
import EmailSubscription from '../components/sections/EmailSubscription';
import FAQ from '../components/sections/FAQ';
import Features from '../components/sections/Features';
import Hero from '../components/sections/Hero';
import KeyFeatures from '../components/sections/KeyFeatures';
import Reality from '../components/sections/Reality';
import UdemyCourse from '../components/sections/UdemyCourse';
import WhatIsTesting from '../components/sections/WhatIsTesting';
import WhereToBuy from '../components/sections/WhereToBuy';
import WhyJestAndTestingLibrary from '../components/sections/WhyJestAndTestingLibrary';
import { I18nProvider, useI18n } from '../i18n/I18nProvider';
import { DEFAULT_LOCALE } from '../i18n/config';
import { AMAZON_URL, LEANPUB_URL, UDEMY_URL } from '../lib/constants';

const Index = () => {
  return (
    <I18nProvider initialLocale={DEFAULT_LOCALE}>
      <IndexContent />
    </I18nProvider>
  );
};

const IndexContent = () => {
  const { t } = useI18n();

  return (
    <>
      <Helmet>
        <title>{t.meta.title}</title>
        <meta name='description' content={t.meta.description} />
        <meta name='keywords' content='angular, testing, jest, testing library, unit testing, signals, guía' />
        <meta property='og:title' content={t.meta.title} />
        <meta property='og:description' content={t.meta.description} />
        <meta property='og:type' content='website' />
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:title' content={t.meta.title} />
        <meta name='twitter:description' content={t.meta.description} />
        <html lang='es' />
        <link rel='alternate' hrefLang='en' href='/en' />
        <link rel='alternate' hrefLang='es' href='/' />
        <link rel='canonical' href='/' />
      </Helmet>

      <div className='min-h-screen flex flex-col'>
        <Header leanpubUrl={LEANPUB_URL} />
        <main className='flex-grow'>
          <Hero leanpubUrl={LEANPUB_URL} />
          <EmailSubscription />
          <BookCover />
          <WhereToBuy amazonUrl={AMAZON_URL} leanpubUrl={LEANPUB_URL} />
          <WhatIsTesting />
          <KeyFeatures />
          <WhyJestAndTestingLibrary />
          <Chapters />
          <Reality />
          {/* <Testimonials /> */}
          <Features />
          {/* <Videos /> */}
          <Content />
          <FAQ />
          <CoursesSection />
          <UdemyCourse udemyUrl={UDEMY_URL} />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
